import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { MedicalVisit } from "../types/FormTypes";
import * as Yup from "yup";
import { medicalVisitAtom } from "./AddCertificate";
import { useRef } from "react";
import { useIsAddMoreTrue } from "./AddMore";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  handleSubmitClick,
  ErrorList,
  Button,
  Progressbar,
  RadioGroupForm,
  Heading,
} from "@ogt/ui";

export const BY_PRIVATE = "byPrivate";
export const BY_PUBLIC = "byPublic";
export const BY_BOTH = "byBoth";

export default function TravelDetails() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(medicalVisitAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const [isAddMoreTrue] = useIsAddMoreTrue();
  const progress = isAddMoreTrue ? 87 : 50;

  return (
    <div>
      <Formik<MedicalVisit>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          if (values.wayOfTravel === BY_PRIVATE) {
            navigate("../bil");
          } else if (values.wayOfTravel === BY_PUBLIC) {
            navigate("../kollektivtrafik");
          } else if (values.wayOfTravel === BY_BOTH) {
            navigate("../bil-och-kollektivtrafik");
          }
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          wayOfTravel: Yup.string().test(
            "at-least-one-radio-selected",
            "Vänligen välj ett svaralternativ för att gå vidare till nästa fråga",
            (value) => {
              return (
                value === BY_PRIVATE || value === BY_PUBLIC || value === BY_BOTH
              );
            }
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-40 w-full max-w-xs mb-4">
                {isAddMoreTrue ? (
                  <Progressbar percentage={progress} />
                ) : (
                  <Progressbar percentage={progress} />
                )}{" "}
              </div>
            </div>
            <Form ref={formRef} noValidate>
              <Box>
                <Heading
                  progress={progress}
                  headingRef={h2Ref}
                  focusable
                  id="wayOfTravelHeading"
                >
                  Om resan
                </Heading>

                <ErrorList errors={errors} />

                <RadioGroupForm
                  name="wayOfTravel"
                  orientation="vertical"
                  required
                  legend="Hur reste du till och från vårdenheten? "
                  variant="box"
                  options={[
                    {
                      id: "withCar",
                      value: BY_PRIVATE,
                      label: "Med privatbil",
                    },
                    {
                      id: "withPublicTransport",
                      value: BY_PUBLIC,
                      label:
                        " Med kollektivtrafik (tåg, buss, båt), taxi eller flyg",
                    },
                    {
                      id: "withBoth",
                      value: BY_BOTH,
                      label:
                        "Både privatbil och kollektivtrafik, taxi eller flyg",
                    },
                  ]}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn secondary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
